import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <div className="logo-icon">A</div>
          <span>Award Web and Design Services</span>
        </div>
        <nav className="nav">
          <Link to="/more-about-me" className="nav-link">More About Me</Link>
          <Link to="/resume" className="nav-link">Professional Resume</Link>
          <a href="https://www.linkedin.com/in/russellpope/" className="nav-link linkedin" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header; 